import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import MeetingTitleBox from '../Box/MeetingTitleBox';
import PreviewMeetingDetailCard from '../Card/PreviewMeetingDetailCard';

function PreviewMeetingDialog({ open, onClose, meeting, setPreviewMeetingDialogStatus }) {

  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };
  useEffect(() => {
    if (open) {
      setIsFullScreen(false);
    }
  }, [open]);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={"xl"}
      fullWidth
      fullScreen={isFullScreen}
      PaperProps={{
        sx: {
          backgroundColor: "rgb(245,247,250)",
        },
      }}
    >
      <DialogTitle>
        <MeetingTitleBox
          meeting={meeting}
          toggleFullScreen={toggleFullScreen}
          onClose={onClose}
          isFullScreen={isFullScreen}
        />
      </DialogTitle>
      <DialogContent>
        <PreviewMeetingDetailCard meeting={meeting} setPreviewMeetingDialogStatus={setPreviewMeetingDialogStatus} />
      </DialogContent>

    </Dialog>
  );
}


export default PreviewMeetingDialog